var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerfomance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.89349L15.5 1L30 8.89349L15.5 16.787L1 8.89349Z",
    stroke: "#7A5AF8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 26.6538V12.8402L15.5 8.89349",
    stroke: "#7A5AF8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6169 10.7358V17.4602C26.6173 17.673 26.5499 17.8802 26.4248 18.0506C25.6108 19.1562 22.1767 23.201 15.5002 23.201C8.82382 23.201 5.38963 19.1562 4.57562 18.0506C4.45056 17.8802 4.38315 17.673 4.38355 17.4602V10.7358",
    stroke: "#7A5AF8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfomance);
export default __webpack_public_path__ + "static/media/Perfomance.31711a9f56fe63fa913a6b00db9675b5.svg";
export { ForwardRef as ReactComponent };